import React from 'react';
import './Header.css';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

function Header({
  isMobile,
  sidebarOpen,
  toggleSidebar,
  sidebarRef,
  seriesDropdownOpen,
  characterDropdownOpen,
  systemActivityDropdownOpen,
  toggleSeriesDropdown,
  toggleCharacterDropdown,
  toggleSystemActivityDropdown,
  seriesOptions,
  characterOptions,
  systemActivityOptions,
  convertToPinyin,
  seriesDropdownRef,
  characterDropdownRef,
  systemActivityDropdownRef,
  setSystemActivityDropdownOpen,
  setSeriesDropdownOpen,
  setCharacterDropdownOpen
}) {
  // 你可以把 isMobile、sidebarOpen、toggleSidebar 等 props 傳進來
  // 這裡只舉例，實際內容請依你的 header 結構搬過來

  // 根據 isMobile 決定要渲染哪個 Header
  return (
    <div className={`App ${isMobile ? 'mobile' : 'desktop'}`}>
      {isMobile ? (
        <MobileHeader
          isMobile={isMobile}
          sidebarOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
          sidebarRef={sidebarRef}
          seriesDropdownOpen={seriesDropdownOpen}
          characterDropdownOpen={characterDropdownOpen}
          systemActivityDropdownOpen={systemActivityDropdownOpen}
          toggleSeriesDropdown={toggleSeriesDropdown}
          toggleCharacterDropdown={toggleCharacterDropdown}
          toggleSystemActivityDropdown={toggleSystemActivityDropdown}
          seriesOptions={seriesOptions}
          characterOptions={characterOptions}
          systemActivityOptions={systemActivityOptions}
          convertToPinyin={convertToPinyin}
          seriesDropdownRef={seriesDropdownRef}
          characterDropdownRef={characterDropdownRef}
          systemActivityDropdownRef={systemActivityDropdownRef}
          setSystemActivityDropdownOpen={setSystemActivityDropdownOpen}
          setSeriesDropdownOpen={setSeriesDropdownOpen}
          setCharacterDropdownOpen={setCharacterDropdownOpen}
        />
      ) : (
        <DesktopHeader
          isMobile={isMobile}
          sidebarOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
          sidebarRef={sidebarRef}
          seriesDropdownOpen={seriesDropdownOpen}
          characterDropdownOpen={characterDropdownOpen}
          systemActivityDropdownOpen={systemActivityDropdownOpen}
          toggleSeriesDropdown={toggleSeriesDropdown}
          toggleCharacterDropdown={toggleCharacterDropdown}
          toggleSystemActivityDropdown={toggleSystemActivityDropdown}
          seriesOptions={seriesOptions}
          characterOptions={characterOptions}
          systemActivityOptions={systemActivityOptions}
          convertToPinyin={convertToPinyin}
          seriesDropdownRef={seriesDropdownRef}
          characterDropdownRef={characterDropdownRef}
          systemActivityDropdownRef={systemActivityDropdownRef}
          setSystemActivityDropdownOpen={setSystemActivityDropdownOpen}
          setSeriesDropdownOpen={setSeriesDropdownOpen}
          setCharacterDropdownOpen={setCharacterDropdownOpen}
        />
      )}
    </div>
  );
}

export default Header;
